import { Box, Typography } from "@mui/material";
import React from "react";

import { EntityRef } from "../../types/productPlane";
import EntityLink from "../Detail/EntityLink";

export interface PathTrailProps {
  // The entries above the page's own entity, from the top down; each is a
  // link
  above: EntityRef[];
  // The page's own entity, which ends the trail and is not a link
  own: string;
}

const separator = (
  <Box component="span" aria-hidden sx={{ color: "text.disabled" }}>
    ›
  </Box>
);

/**
 * Where the page's entity sits, above its title: the entries above it as
 * links and its own name at the end, unlinked, all at caption size.
 */
const PathTrail: React.FC<PathTrailProps> = ({ above, own }) => (
  <Typography
    component="nav"
    aria-label="Path"
    variant="caption"
    color="text.secondary"
    sx={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "baseline",
      columnGap: 0.75,
      mb: 0.5,
    }}
  >
    {above.map((entry) => (
      <React.Fragment key={entry.id}>
        <EntityLink id={entry.id} type={entry.type} name={entry.name} />
        {separator}
      </React.Fragment>
    ))}
    <Box component="span" aria-current="page" sx={{ color: "text.primary" }}>
      {own}
    </Box>
  </Typography>
);

export default PathTrail;
